/* eslint-disable react/display-name */
import React, { useState, useEffect, useRef } from 'react';
import propTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { GET_LIST_POSTWEB, DELETE_POSTWEB } from '../../constants/config';
import { PER_PAGE } from '../../constants/variable';
import { confirmDelete } from '../../helpers/table';
import createNotification from '../../component/common/Notification';
import { postData, deleteById } from '../../services/base_services';

import Table from '../../component/common/Table';
import Paginate from '../../component/Paginate';
import NewButton from '../../component/common/NewButton';
import InputSearch from '../../component/common/InputSearch';
import editIcon from '../../assets/images/icon/edit-kn.svg';
import deleteIcon from '../../assets/images/icon/delete-kn.svg';

const AdsTable = (props) => {
  const { history } = props;
  const [tableData, setTableData] = useState([]);
  const [paginate, setPaginate] = useState([]);
  const [numberDelete, setNumberDelete] = useState(0);
  const typingTimeoutRef = useRef(null);
  const [key, setKey] = useState('');
  const [idEvent, setIdEvent] = useState('');
  const [req, setReq] = useState({
    keyword: key,
    page: 1,
    // eslint-disable-next-line camelcase
    per_page: PER_PAGE || 5,
    event_id: idEvent,
    date: ''
  });

  const tableHeaders = [
    {
      label: 'STT',
      index: 'stt',
      option: {
        className: 'text-center position-relative'
      },
      callback: null
    },
    {
      label: 'Tiêu đề',
      index: null,
      callback: (data) => {
        return (
          <div>
            <span>{data && data.title}</span>
          </div>
        );
      }
    },
    {
      label: 'Loại Bài Viết',
      index: null,
      option: {
        className: 'text-center'
      },
      callback: (data) => {
        return (
          <div>
            <span>{data && data.menu_name}</span>
          </div>
        );
      }
    },
    {
      label: 'CHỨC NĂNG',
      index: null,
      option: {
        className: 'text-center fixed-collumn'
      },
      callback: (data) => {
        if (data && data.id) {
          return (
            <div className="btn-group">
              <span
                data-tip="Chỉnh Sửa Bài Viết"
                className="link-action ml-2 mr-2"
              >
                <div
                  role="button"
                  tabIndex={0}
                  onClick={() => onEditPostWeb(data.id)}
                  onKeyPress={() => {}}
                >
                  <img alt="edit" src={editIcon} className="btn-icon" />
                </div>
              </span>
              <span data-tip="Xóa Bài Viết" className="link-action ml-2">
                <div
                  role="button"
                  tabIndex={0}
                  onClick={() => onDeletePostWeb(data.id)}
                  onKeyPress={() => {}}
                >
                  <img alt="delete" src={deleteIcon} className="btn-icon" />
                </div>
              </span>
              <ReactTooltip
                className="tooltip-button"
                place="bottom"
                effect="float"
              />
            </div>
          );
        }
        return '';
      }
    }
  ];

  const getListPostWeb = async (newReq) => {
    //getListEventForm
    await postData(GET_LIST_POSTWEB, newReq)
      .then((res) => res && res.data)
      .then((res) => {
        setPaginate({ ...res?.paginate, perPage: req?.per_page });
        setTableData(res && res.data);
      });
  };
  const deletePostWeb = (id) => {
    deleteById(DELETE_POSTWEB, id).then(() => {
      setNumberDelete(numberDelete + 1);
      createNotification('success', `Xóa thông tin bài viết thành công!`);
    });
  };
  const onEditPostWeb = (id) => {
    history.push(`/postweb/edit/${id}`);
  };
  const onDeletePostWeb = (id, name) => {
    confirmDelete().then((res) => {
      if (res && res.value) {
        deletePostWeb(id, name);
      }
    });
  };
  const changePage = (pageNumber) => {
    setReq({
      ...req,
      page: pageNumber
    });
  };

  const changePerPage = (value) => {
    setReq({
      ...req,
      keyword: key,
      page: 1,
      per_page: value
    });
  };

  const onChangeSearch = (e) => {
    const value = e.target.value ? e.target.value : '';
    setKey(value);
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
    typingTimeoutRef.current = setTimeout(() => {
      setReq({
        ...req,
        keyword: value,
        page: 1
      });
    }, 500);
  };

  useEffect(() => {
    getListPostWeb(req);
  }, [req, numberDelete]);

  return (
    <>
      <section className="body-right-bottom content-wrap">
        <div className="container-fluid content">
          <div className="row top-table">
            <div className="col-md-12 top-table-title">
              <p>Quản Lý Bài Viết Trên Website </p>
            </div>
            <div className="col-md-1 top-table-border "></div>
          </div>
          <div className="content-form content-form--donate">
            <div className="row">
              <div className="col d-flex">
                <div className="ml-auto d-flex flex-wrap px-15px">
                  <InputSearch onChange={onChangeSearch} />
                </div>
                <Link to="/postweb/new">
                  <NewButton />
                </Link>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Table
                tableData={tableData}
                tableHeaders={tableHeaders}
                tablePaginate={paginate}
              />
            </div>
            <div className="table-pagenatie ml-auto">
              <div className="paginate-wrapper">
                <Paginate
                  paginate={paginate}
                  changePage={changePage}
                  per_page={req?.per_page}
                  tablePaginate={paginate}
                  changePerPage={changePerPage}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default withRouter(AdsTable);

AdsTable.propTypes = {
  history: propTypes.isRequired
};
